<template>
  <span>
    <i class="fa-solid fa-person-walking-luggage" /> {{ distance }}
  </span>
</template>

<script>
export default {
  name: 'WalkingDistance',
  props: {
    distanceInKm: {
      type: Number,
      required: true,
    },
  },
  computed: {
    distance() {
      const distanceInMinutes = Math.round((this.distanceInKm * 60) / 3.5);
      if (distanceInMinutes > 30) {
        return `${Math.round(this.distanceInKm)} km`;
      }
      return `${distanceInMinutes} min`;
    },
  },
};
</script>

<style scoped>

</style>
